<template>
    <div class="document wrapper">
        <div class="w3-row">
            <div class="w3-col s12">
                <img v-if="$i18n.locale === 'ko'" src="@/static/img/kr/how_to_loan.png" class="w3-image">
                <img v-else-if="$i18n.locale === 'vi'" src="@/static/img/vn/how_to_loan.png" class="w3-image">
                <img v-else-if="$i18n.locale === 'my'" src="@/static/img/mm/how_to_loan.png" class="w3-image">
                <img v-else-if="$i18n.locale === 'ne'" src="@/static/img/np/how_to_loan.png" class="w3-image">
                <img v-else-if="$i18n.locale === 'uz'" src="@/static/img/uz/how_to_loan.png" class="w3-image">
                <img v-else-if="$i18n.locale === 'lk'" src="@/static/img/lk/how_to_loan.png" class="w3-image">
                <img v-else-if="$i18n.locale === 'kh'" src="@/static/img/kh/how_to_loan.png" class="w3-image">
                <img v-else-if="$i18n.locale === 'ph'" src="@/static/img/ph/how_to_loan.png" class="w3-image">
                <img v-else src="@/static/img/us/how_to_loan.png" class="w3-image">
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>

<script>
export default {
  name: 'documnet'
}
</script>
